import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { IFieldConfig } from "@shared/lib/types/briefInfluencerV2";
import {
  BRIEF_DATA_FIELDS_QUERY_KEY,
  BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY,
  BRIEF_LIST_QUERY_KEY,
} from "../constants";
import { BriefService } from "../services/brief.service";

interface ICreateBriefDataFieldsRequest {
  briefId: string;
  customFieldsV2: IFieldConfig;
}

export function useCreateBriefDataFields(briefId: string) {
  const {
    mutate: createDataFields,
    isLoading: isCreating,
    isSuccess: isCreated,
  } = useMutation({
    mutationFn: (data: ICreateBriefDataFieldsRequest) =>
      BriefService.createBriefDataFieldsV2(
        data.briefId,
        data.customFieldsV2
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY, briefId],
      });
      c.invalidateQueries({
        queryKey: [...BRIEF_LIST_QUERY_KEY, briefId],
      });
      c.invalidateQueries({
        queryKey: [...BRIEF_DATA_FIELDS_QUERY_KEY, briefId],
      });
    },
  });

  return {
    createDataFields,
    isCreating,
    isCreated,
  };
}
